module.exports = __webpack_public_path__ + "img/miranda.25fcadaf.jpg";